import { useMutation } from 'react-query';
import { postLoginFromAPI } from './login.api';
import { IParamLogin } from './login.types';

export const actionPostLogin = () =>
  useMutation((payload: IParamLogin) => postLoginFromAPI(payload));
